import React from 'react';
import { fieldProps } from './field-shape';
import {
  Radio,
  Label,
  ChoiceText,
  Flex,
} from '@leagueplatform/genesis-commons';

export const RadioField = ({
  field: { name, value, ...field },
  form: { setFieldValue },
  id,
  disabled,
  readOnly,
  options,
  hasError,
}) => {
  const isDisabled = Boolean(disabled ?? readOnly);
  const isBooleanField = options.some(
    option => typeof option.value === 'boolean',
  );
  return (
    <Flex
      height="three"
      alignItems="center"
      role="radiogroup"
      aria-labelledby={`${id}_label`}
    >
      {options?.map((option, idx) => (
        <Label
          key={`${name}_${option.value}`}
          marginLeft={idx > 0 ? 'one' : 'none'}
          display="flex"
        >
          <Radio
            // eslint-disable-next-line react/jsx-props-no-spreading -- FIXME: automatically added for existing issue
            {...field}
            name={name}
            value={option.value}
            disabled={isDisabled}
            checked={option.value === value}
            error={hasError}
            onChange={({ target }) => {
              const newValue = isBooleanField
                ? target.value === 'true'
                : target.value;
              setFieldValue(name, newValue);
            }}
          />
          <ChoiceText marginLeft="threeQuarters">{option.label}</ChoiceText>
        </Label>
      ))}
    </Flex>
  );
};

RadioField.propTypes = fieldProps;
